<template>
	<div>
		<Header></Header>
		<!-- <Nav></Nav> -->
		<div class="ordercenter">
			<div class="order">
				<div class="order-left">
					<p class="order-title">订单中心</p>
					<li @click="myOrder(0)" class="my-order" :class="{active:isActive== 0}">我的订单</li>
					<p class="order-title">客户服务</p>
					<li @click="myOrder(1)" class="my-order" :class="{active:isActive== 1}">发票信息</li>
					<li @click="myOrder(2)" class="my-order" :class="{active:isActive== 2}">我的发票</li>
					<!-- <li @click="myOrder(1)" class="my-order" :class="{active:isActive== 1}" v-show="level != 2">审批订单</li> -->
				</div>
				<div class="order-list" v-if="showInvoice==1">
					<div class="ttshop-userights">
						<div class="ttshop-myorder clearfloat">
							<ul class="clearfloat">
								<li @click="orderTab(0)" :class="{active:currTab ==0}">全部订单</li>
								<li @click="orderTab(1)" :class="{active:currTab ==1}">售后</li>
								<!-- <li @click="orderTab(2)" v-show="level != 0 || level_num ==1"  :class="{active:currTab ==2}">已通过</li> -->
								<!-- <li @click="orderTab(3)" v-show="level != 0 || level_num ==1"  :class="{active:currTab ==3}">未通过</li> -->
							</ul>
							<div class="ttshop-myorderseach">
								<input type="text" placeholder="请输入您的订单名称" v-model="order_txt" ref="order_txt">
								<button @click="lookupOrder()">搜索</button>
							</div>
						</div>
						<!-- 订单列表 -->
						<div class="ttshop-myorderlist">
							<div class="ttshop-myordertitle clearfloat">
								<div style="float:left;width:690px;" class="clearfloat">
									<div class="ttshop-myordertext">
										<div class="ttshop-myordertexter clearfloat">
											<!-- <p>近三个月订单</p> -->
											<!-- <select> -->
												<!-- <option>全部订单</option> -->
												<!-- <option @click="orderAll = 0">全部订单</option>
												<option @click="orderAll = 1">近三个月订单</option>
												<option @click="orderAll = 2">近七日订单</option>
												<option @click="orderAll = 3">今日订单</option> -->
											<!-- </select> -->
											<div>全部订单</div>
										</div>
									</div>
									<div class="ttshop-myorderdj">
										<p>单价</p>
									</div>
									<div class="ttshop-myorderdj">
										<p>数量</p>
									</div>
									<div class="ttshop-myorderdjs">
										<p>收货人</p>
									</div>
									<div class="ttshop-myorderzfje">
										<p>支付总金额</p>
									</div>
								</div>
								<div class="ttshop-myordercz">
									<p>操作</p>
								</div>
							</div>
							<!-- 暂无订单展示 -->
							<div v-show="list.length == 0">
								<div class="ttshop-myorderzw" v-show="finish">
									<img src="../../../assets/images/ttshop_zanwu.png" alt="">
									<p>暂无订单</p>
								</div>
							</div>
							<div class="ttshop-myordercon" v-for="(item,index) in order_list" v-model="index"  v-show="currTab == 0">
								<div class="ttshop-myorderconed clearfloat">
									<div class="ttshop-myordercontitle clearfloat">
										<p>{{item.addtime}}</p>
										<p style="margin-left: 10px;">订单号：<span>{{item.order_no}}</span></p>
										<div class="addkf clearfloat" v-if="kfurl && kfurl.length">
											<span>客服:</span>
											<strong v-for="(item,index) in kfurl" :key="index"  @click="openkf(item.jump_url)"><img src="../../../assets/images/kfs.png" alt=""></strong>
										</div>
										<div class="ttshop-myordercontitle-right" v-show="jurisdiction == 0">
											 <!-- v-show="item.is_examine == 0" -->
											<div>
												<p class="ttshop-over" v-if="item.apply_delete == 1 && item.is_cancel==1">已取消</p>
												<p class="ttshop-over" v-if="item.apply_delete == 1 && item.is_cancel==0">申请取消中</p>
													<template v-else-if="item.apply_delete == 0 && item.is_pay == 0">
														<template v-if="item.is_pay == 0">
															<h4 class="ttshop-over">未支付</h4>
															<!-- <h4 v-if="list.is_send == 0 && list.apply_delete == 0">待发货</h4>
															<h4 v-if="list.is_send == 1 && list.is_confirm == 0">待收货</h4>
															<h4 v-if="list.is_confirm == 1">已收货</h4> -->
														</template>
													</template>
												<p class="ttshop-over ttshop-over-examine" v-if="item.is_pay == 1 &&item.is_send == 0 && item.apply_delete == 0">待发货</p>
												<p class="ttshop-over ttshop-over-examine" v-if=" item.is_pay == 1 &&item.is_send == 1 && item.is_confirm == 0">待收货</p>
												<p class="ttshop-over ttshop-over-adopt" v-if="item.is_pay == 1 && item.is_confirm == 1">已收货</p>
											</div>
											<!-- <div v-show="item.is_examine == 1">
												<template v-if="item.exa_status == 0">
													<p class="ttshop-over">待审核</p>
												</template>
												<template v-else-if="item.exa_status == 1">
													<p class="ttshop-over" v-if="item.apply_delete == 1">已取消</p>
													<p class="ttshop-over" v-if="item.is_send == 0 && item.apply_delete == 0">待发货</p>
													<p class="ttshop-over ttshop-over-examine" v-if="item.is_send == 1 && item.is_confirm == 0">待收货</p>
													<p class="ttshop-over ttshop-over-adopt" v-if="item.is_confirm == 1">已收货</p>
												</template>
												<template v-else="item.exa_status == 2">
													<p class="ttshop-over">未通过</p>
												</template>
											</div> -->
										</div>
											<div class="ttshop-myordercontitle-right" v-show="jurisdiction == 1">
												<div v-show="item.is_examine == 0">
													<p class="ttshop-over ttshop-over-adopt">已通过</p>
												</div>
												<div v-show="item.is_examine == 1">
													<template v-if="item.exa_status == 0">
														<p class="ttshop-over ttshop-over-examine">待审核</p>
													</template>
													<template v-else-if="item.exa_status == 1">
														<p class="ttshop-over ttshop-over-adopt">已通过</p>
													</template>
													<template v-else="item.exa_status == 2">
														<p class="ttshop-over">未通过</p>
													</template>
												</div>
										</div>
									</div>
									<div class=" clearfloat d-flex orderlist">
										<div class="listitem">
											<div class="ttshop-myorderconlist clearfloat" v-for="(items,idx) in item.goods_list" :key="idx">
												<div class="ttshop-myorderconleft clearfloat">
													<div class="ttshop-orderimg">
														<img :src="items.goods_pic" alt="">
													</div>
													<div class="ttshop-ordertext">
														<h5>{{items.goods_name}}</h5>
														<span v-for="(attr,ids) in items.attr_list" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
													</div>

												</div>
												<div class="ttshop-myorderdj">
													<p><span>{{items.price}}</span></p>
												</div>
												<div class="ttshop-myorderdj ttshop-myorderdjer">
													<p><span>{{items.num}}</span></p>
												</div>
												<div class="ttshop-shr">
													<p>{{item.consignee}}</p>
												</div>
												<div class="ttshop-zfzje">
													<p><span>{{item.pay_price}}</span></p>
												</div>
											</div>
										</div>
										<div class="ttshop-caozuos d-flex  align-items-center justify-content-center">
											<div v-show="jurisdiction == 0">
												<p class="ttshop-cztext"  v-show="item.exa_status != 0 && item.is_confirm != 1 && item.apply_delete == 0 && item.is_send != 1" @click="cancelOrder(item.order_id)">取消订单</p>
												<p class="ttshop-cztext" @click="orderDetails(index)">订单详情</p>
												<p class="ttshop-zf" v-show="item.is_pay==0 &&item.apply_delete != 1 && item.is_cancel!=1" @click="payOrder(item)">立即支付</p>
												<p class="ttshop-cztext" v-show="item.is_send == 1 && item.is_confirm == 0" @click="ConfirmReceipt(item.order_id)">确认收货</p>
												<p class="ttshop-cztext" v-show="item.is_confirm == 1">已收货</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="ttshop-myordercon" v-for="(item,index) in order_list" v-model="index"  v-show="currTab == 1">
								<div class="ttshop-myorderconed clearfloat">
									<div class="ttshop-myordercontitle clearfloat">
										<p>{{item.addtime}}</p>
										<p style="margin-left: 10px;">订单号：<span>{{item.order_no}}</span></p>
										<div class="ttshop-myordercontitle-right" v-show="jurisdiction == 0">
											 <!-- v-show="item.is_examine == 0" -->
											<div>
												<p class="ttshop_over" v-if="item.refund_type == 1">
												  退货退款：{{ item.refund_price }}
												</p>
											</div>
										</div>
											<div class="ttshop-myordercontitle-right" v-show="jurisdiction == 1">
												<div v-show="item.is_examine == 0">
													<p class="ttshop-over ttshop-over-adopt">已通过</p>
												</div>
												<div v-show="item.is_examine == 1">
													<template v-if="item.exa_status == 0">
														<p class="ttshop-over ttshop-over-examine">待审核</p>
													</template>
													<template v-else-if="item.exa_status == 1">
														<p class="ttshop-over ttshop-over-adopt">已通过</p>
													</template>
													<template v-else="item.exa_status == 2">
														<p class="ttshop-over">未通过</p>
													</template>
												</div>
										</div>
									</div>
									<div class=" clearfloat d-flex orderlist">
										<div class="listitem">
											<div class="ttshop-myorderconlist clearfloat" v-for="(items,idx) in item.goods_list" :key="idx">
												<div class="ttshop-myorderconleft clearfloat">
													<div class="ttshop-orderimg">
														<img :src="items.goods_pic" alt="">
													</div>
													<div class="ttshop-ordertext">
														<h5>{{items.goods_name}}</h5>
														<span v-for="(attr,ids) in items.attr_list" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
													</div>
							
												</div>
												<div class="ttshop-myorderdj">
													<p><span>{{items.price}}</span></p>
												</div>
												<div class="ttshop-myorderdj ttshop-myorderdjer">
													<p><span>{{items.num}}</span></p>
												</div>
												<div class="ttshop-shr">
													<p>{{item.consignee}}</p>
												</div>
												<div class="ttshop-zfzje">
													<p><span>{{item.pay_price}}</span></p>
												</div>
											</div>
										</div>
										<div class="ttshop-caozuos d-flex  align-items-center justify-content-center">
											<div>
											  <p class="ttshop_cztext" @click="goOrderxq(item)" style="margin-bottom: 6px;cursor: pointer;">订单详情</p>
											  <p class="ttshop_ljzf" v-if="item.refund_status == 0 && item.is_agree == 0" @click="withdraw(item.order_refund_id)">
											    撤回申请
											  </p>
											  <template v-if="item.refund_type == 1">
											    <template v-if="item.refund_status == 0">
											      <p class="ttshop_cztexts" v-if="item.is_agree == 0">
											        等待审核中
											      </p>
											      <template v-else>
											        <p class="ttshop_cztexts" v-if="item.is_user_send == 0" >
											          已同意退货，请及时发货
											        </p>
											        <p class="ttshop_cztexts" v-else>
											          已发货，待平台确认
											        </p>
											      </template>
											    </template>
											    <p class="ttshop_cztexts" v-if="item.refund_status == 1" >
											      已同意退货并已退款
											    </p>
											    <p class="ttshop_cztexts" v-if="item.refund_status == 3" >
											      已拒绝退货
											    </p>
											  </template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="ttshop-myorderpage clearfloat">
								<el-pagination class="ttshop-pages" @current-change="handleCurrentChangeMyorder" :current-page.sync="myorder_page" background
								 layout="prev, pager, next" :hide-on-single-page="true" @prev-click="myorder_perv" @next-click="myorder_next" :page-count="order_list_num"></el-pagination>
							</div>
						</div>
					</div>
				</div>
				<div v-else-if="showInvoice==2" style="width:100%">
				<Invoice></Invoice>
				</div>
				<div v-else>
					<AllInvoice></AllInvoice>
				</div>
			</div>
		</div>

		<!-- 审批订单 -->
		<div class="addpersonal">
			<el-dialog class="addper-txt" title="未通过的原因" :visible.sync="orderApproval">
				<div class="addper">
					<div class="add-per">
						<textarea class="add-per-text" placeholder="输入未通过的原因" v-model="refuseContent"></textarea>
					</div>
					<div class="newly-build" @click="orderRefuse()">
						提交
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 支付弹层 -->
		<div class="ttshop_pay">
			<el-dialog  :before-close="handleClose" :visible.sync="pay_cont_type" >
				<div class="pay-title d-flex align-items-center justify-content-center">扫码支付</div>
				<div class="pay-qrcode d-flex align-items-center justify-content-center" v-if="pay_cont_type">
					<div id="qrcode" ></div>
				</div>
			</el-dialog>
		</div>

		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Nav from "@/components/purchase/nav/nav";
	import Footer from "@/components/purchase/footer/footer";
	import "./ordercenter.css";
	import QRCode from "qrcodejs2";
	let Base64 = require("js-base64").Base64;
	import Invoice from './Invoice'
	import AllInvoice from './AllInvoice'
	export default {
		components: {
			Header,
			Nav,
			Footer,
			Invoice,
			AllInvoice
		},
		data() {
			return {
				showInvoice:1,
				pay_cont_type: false, //支付二维码弹层
				route_url: this.$store.state.route_url,
				enterprise_name: this.$store.state.qycg_user.nickname,
				isActive: 0,
				list: [],
				finish: false,
				currTab: 0,
				items: ['我的订单', '审批订单'],
				pageShow: true, //分页
				jurisdiction: 0,
				page_count: 0,
				page: 1,
				limit: 10,
				refuseContent:'',  //拒绝内容
				orderApproval: false,
				orderAll: 0, //订单列表 0为全部 1为待审核 2为已审批 3为未通过
				myselfOrder: 0, //0为个人订单  1为审批订单
				// orderApp: 0, //审批订单显示或隐藏
				department_id: '', //部门id
				level: '', //职位  0 一级管理员 1 部门审核员 2 采购员
				level_num: 0,
				id: '', //用户id
				access_token: '', //用户登录唯一标识
				order_list: [], //订单列表
				length: '',
				orderIndex: '',
				order_txt:'',   //订单关键字查找
				myorder_page: 1,   //订单分页
				myorder_count: 6,  //订单分页
				order_list_num: 0,
				kfurl:[],
				
			}
		},
		 computed: {
				userdata:function(){
					return this.order_list.slice((this.page)*this.page_count,this.page*this.page_count);
				},
			},
		created() {
			this.basicInformation();
			this.getOrderList();
			let that = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					if (that.$refs.order_txt.value) {
						that.getOrderList();
					}
				}
			};
		},
		methods: {
			// 立即支付
			payOrder(i){
				this.$api.payData({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						pay_type: i.pay_type,
						order_id:i.order_id
				}).then(res=>{
					if(res.code==0){
								this.pay_cont_type = true;
									this.order_status_query = setInterval(() => {
									this.orderStatus(res.res.order_no);
								}, 5000);
								let url = Base64.decode(res.res.code_url);
								this.$nextTick(()=>{
									this.qrcodeScan(url);
									})
					}else{
 							this.$message({
              	type: 'info',
              	message: res.msg
            	});
					}
				})
			},
				qrcodeScan(url) {
				//生成二维码
				return new QRCode("qrcode", {
					width: 150, // 二维码宽度
					height: 150, // 二维码高度
					text: url,
					colorDark:"#000",
					colorLight:"#fff"
				});
			},
			//取消支付
			 handleClose(done) {
        this.$confirm('确认取消支付吗？')
          .then(_ => {
						clearInterval(this.order_status_query);
						this.getOrderList()
            done();
          })
          .catch(_ => {});
      },
		//订单状态
			orderStatus(order) {
				let that = this;
				let params = {
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					order_no: order,
				}
				this.$api.qycgorderStatus(params).then((res) => {
					if (res.code == 0) {
						clearInterval(that.order_status_query);
						that.$message({
							type: "success",
							message: '订单支付成功',
							showClose: true,
							offset: 200,
							duration: 1000,
						});
						this.pay_cont_type = false
					this.getOrderList()
					}
				}).catch((err) => {
					console.log(err)
				});
			},
			// 获取基础信息
			basicInformation() {
				let user = this.$store.state.qycg_user;
				this.department_id = user.department_id;
				this.access_token = this.$store.state.qycg_user.access_token;
				this.level = user.level;
				this.id = user.id;
			},
			//在线客服
			openkf(){
				window.open("https://www.baidu.com/");
			},
			myOrder(i) {
				if(i==0){
				this.isActive = i;
				this.jurisdiction = i;
				this.myselfOrder = i;
				this.getOrderList();
				this.level_num = i;
				this.showInvoice=1
				}else if(i==1){
					this.isActive = i
				this.showInvoice=2
				}else{
					this.isActive = i
					this.showInvoice=3
				}
				
			},
			//订单输入关键字查找
			lookupOrder(){
				this.getOrderList()
			},
			// 获取订单列表
			getOrderList() {
				this.finish = false;
				// console.log(this.department_id)
				let dep_id = this.department_id;
				let access_token = this.access_token;
				let type = this.myselfOrder;
				let status = this.orderAll;
				let page = this.myorder_page;
				let limit = this.myorder_count;
				let keyword = this.order_txt;
				this.$api.qycgOrderList({
					shop_type: 'qycg',
					access_token: access_token,
					type: type,
					dep_id:dep_id,
					status: status,
					page:page,
					limit: limit,
					keyword: keyword,
				}).then((res) => {
					this.order_list = res.data.list;
					this.page_count = res.data.page_count;
					this.finish = true;
					this.pay_type_list = res.data.pay_type_list;
					this.length =  res.data.list.length;
					this.order_list_num = res.data.page_count;
					this.kfurl = JSON.parse(res.data.customer_list);
					this.order_txt = '';
					if (res.data.page_count == 1) {
						this.pageShow = false;
					} else {
						this.pageShow = true;
					}
					if(this.order_list.length > 0){
						this.finish = false
					}
				}).catch((err) => {
					// console.log(err);
				});
			},
			//订单详情
			orderDetails(index){
				let orderId = this.order_list[index].order_id;
				this.$router.push(this.common.qycgrouter(this) + "/orderdetails");
				this.$store.commit("orderDetailsId", orderId);
			},
			//订单审批  通过
			orderAdopt(index){
				let order_id = this.order_list[index].order_id;
				let dep_id = this.department_id;
				let access_token = this.access_token;
				let status = 1;
				let page = this.myorder_page;
				let limit = this.myorder_count;
				this.$api.orderReview({
					shop_type: 'qycg',
					access_token: access_token,
					order_id: order_id,
					dep_id: dep_id,
					page:page,
					limit: limit,
					status: status,
				}).then((res) => {
					this.$message({
						showClose: true,
						message: '成功通过',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.getOrderList();
				}).catch((err) => {
					// console.log(err);
				});
			},
			//拒绝弹框
			refuseKuang(index){
				this.orderApproval = true;
				this.orderIndex = index;
			},
			//订单审核  拒绝
			orderRefuse(){
				let index = this.orderIndex;
				let order_id = this.order_list[index].order_id;
				let dep_id = this.department_id;
				let access_token = this.access_token;
				let status = 2;
				let content = this.refuseContent;
				this.$api.orderReview({
					shop_type: 'qycg',
					access_token: access_token,
					order_id: order_id,
					dep_id: dep_id,
					status: status,
					content: content,
				}).then((res) => {
					this.$message({
						showClose: true,
						message: '已拒绝',
						type: 'success',
						offset: 200,
						duration: 1000
					});
					this.orderApproval = false;
					this.getOrderList();
				}).catch((err) => {
					this.$message({
						showClose: true,
						message: err.msg,
						type: 'success',
						offset: 200,
						duration: 1000
					});
					// console.log(err);
				});
			},
			// 取消订单
			cancelOrder(id) {
				// console.log(id)
				this.$confirm("确定取消订单？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$api
							.cancelOrder({
								shop_type: 'qycg',
								access_token: this.$store.state.qycg_user.access_token,
								order_id: id,
							})
							.then((res) => {
								if (res.code == 0) {
									// clearInterval(this.time);
									// console.log(res)
									this.$message({
										type: "success",
										message: res.msg,
										showClose: true,
										offset: 200,
										duration: 1000,
									});
									// this.shopVisible = false;
									// this.$router.push("/ttshop_mybalance");
									this.getOrderList();
								}
							})
							.catch((err) => {
								// console.log(err)
							});
					})
					.catch(() => {
						this.$message({
						  type: "info",
						  message: "已取消删除",
						});
					});
			},
			// 确认收货
			ConfirmReceipt(order_id) {
				let id = order_id
				this.$api
					.ConfirmReceipt({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						order_id: id,
					})
					.then((res) => {
						if (res.code == 0) {
							// clearInterval(this.time);
							// console.log(res)
							this.$message({
								type: "success",
								message: res.msg,
								showClose: true,
								offset: 200,
								duration: 1000,
							});
							// this.shopVisible = false;
							// this.$router.push("/ttshop_mybalance");
							this.getOrderList();
						}
					})
					.catch((err) => {
						// cconsole.log(err)
					});
			},
			//切换
			orderTab(i) {
				if(this.currTab === i){
					return false;
				}
				this.currTab = i;
				if(i == 0){
					this.getOrderList()
				}else if(i == 1){
					this.getshOrderList();
				}
			},
			getshOrderList() {
				this.finish = false;
				// console.log(this.department_id)
				let dep_id = this.department_id;
				let access_token = this.access_token;
				let type = this.myselfOrder;
				let status = this.orderAll;
				let page = this.myorder_page;
				let limit = this.myorder_count;
				let keyword = this.order_txt;
				this.$api.shlist({
					shop_type: 'qycg',
					access_token: access_token,
					type: type,
					dep_id:dep_id,
					status: status,
					page:page,
					limit: limit,
					keyword: keyword,
				}).then((res) => {
					// console.log(res)
					this.order_list = res.data.list;
					this.page_count = res.data.page_count;
					this.finish = true;
					this.pay_type_list = res.data.pay_type_list;
					this.length =  res.data.list.length;
					this.order_list_num = res.data.page_count;
					this.order_txt = '';
					if (res.data.page_count == 1) {
						this.pageShow = false;
					} else {
						this.pageShow = true;
					}
					if(this.order_list.length > 0){
						this.finish = false
					}
				}).catch((err) => {
					// console.log(err);
				});
			},
			//撤回申请
			withdraw(id) {
			  this.$confirm("是否撤回申请？", "提示", {
			    confirmButtonText: "确定",
			    cancelButtonText: "取消",
			    type: "warning",
			  })
			    .then(() => {
			      this.$api
			        .chshouhou({
			          order_type: "SHOP",
			          order_refund_id: id,
					  access_token : this.$store.state.qycg_user.access_token,
			        })
			        .then((res) => {
			          this.$message({
			            type: "success",
			            message: res.msg,
			            showClose: true,
			            offset: 200,
			            duration: 1000,
			          });
			          this.getshOrderList();
			        })
			        .catch((err) => {
			          // console.log(err);
			          this.$message({
			            type: "success",
			            message: err.msg,
			            showClose: true,
			            offset: 200,
			            duration: 1000,
			          });
			        });
			    })
			    .catch(() => {
			      // this.$message({
			      //   type: "info",
			      //   message: "已取消删除",
			      // });
			    });
			},
			goOrderxq(item) {
				console.log(item.order_refund_id)
				this.$router.push({
					path: this.common.qycgrouter(this) +"/shorderdetails",
					query: {
					  id: item.order_refund_id,
					},
				});
			},
			// 订单输入分页
			handleCurrentChangeMyorder(e) {
				this.myorder_page = e;
				this.common.backTop();
				if(this.currTab == 0){
					this.getOrderList();
				}else if(this.currTab == 1){
					this.getshOrderList();
				}
			},
			//订单上一页
			myorder_perv() {
				this.myorder_page--;
				this.common.backTop();
				this.getOrderList();
			},
			// 订单下一页
			myorder_next() {
				this.myorder_page++;
				this.common.backTop();
				this.getOrderList();
			},
		}
	}
</script>

<style lang="scss" scoped>
.ttshop_pay {
	.pay-title{
			width: 100%;
			font-size: 14px;
			font-weight: 700;
			margin-bottom: 10px;
			.pay-qrcode {
			width: 200px;
			height: 200px;
	}
}

}
	.addkf{
		float: left;
		padding-top: 5px;
		box-sizing: border-box;
		margin-left: 8px;
		span{
			float: left;
			font-size: 12px;
			color: #999;
			font-weight: 400;
			margin-right: 6px;
			line-height: 20px;
		}
		strong{
			float: left;
			width: 20px;
			height: 20px;
			margin-top: 1px;
			cursor: pointer;
			margin-right: 4px;
			&:last-child{margin-right: 0;}
			img{
				display: block;
				width: 100%;
			}
		}
	}
	.ttshop_ljzf {
	  display: block;
	  width: 72px;
	  height: 24px;
	  border: 1px solid #ff3346;
	  background: #fff0f1;
	  line-height: 24px;
	  text-align: center;
	  font-size: 12px;
	  color: #ff0e25;
	  margin: 0 auto 8px;
	  border-radius: 2px;
	  cursor: pointer;
	}
	.ttshop_cztexts {
	  font-size: 12px;
	  color: #ff0e25;
	  margin-bottom: 8px;
	}
	.ordercenter {
		width: 100%;
		min_height: 728px;
		_height: 728px;
		background: #F2F2F2;
		padding-top: 20px;

		.order {
			width: 1080px;
			// height: 733px;
			margin: 0 auto;
			background: #FFFFFF;
			display: flex;

			.order-left {
				width: 186px;
				height: 728px;
				box-sizing: border-box;
				border-right: 1px solid #F5F5F5;

				.order-title {
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					line-height: 12px;
					margin: 20px 0 14px 24px;
				}

				.my-order {
					box-sizing: border-box;
					color: #333333;
					width: 161px;
					height: 40px;
					line-height: 40px;
					border-radius: 0px 6px 6px 0px;
					padding-left: 24px;
					position: relative;
					cursor: pointer;
					border-left: 2px solid #FFFFFF;
				}

				.active {
					color: #FF3259;
					background: rgba(255, 0, 0, 0.1);
					border-left: 2px solid red;
					box-sizing: border-box;
				}
			}

			.order-list {
				width: 894px;
				// height: 733px;

				.ttshop-userights {
					padding: 16px 24px;
					box-sizing: border-box;
					background: #fff;

					.ttshop-myorder {
						width: 100%;
						margin-bottom: 16px;

						ul {
							float: left;

							li {
								float: left;
								font-size: 12px;
								color: #333;
								font-weight: 600;
								line-height: 12px;
								padding: 8px 0;
								box-sizing: border-box;
								margin-right: 24px;
								cursor: pointer;
								position: relative;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&::before {
									content: "";
									width: 0%;
									height: 2px;
									background: #ff0e25;
									position: absolute;
									bottom: -2px;
									left: 50%;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;
									transform: translateX(-50%);
									-moz-transform: translateX(-50%);
									-webkit-transform: translateX(-50%);
									-o-transform: translateX(-50%);
								}

								&:hover {
									color: #ff0e25;
								}

								&:hover::before {
									width: 100%;
								}

								&.active {
									font-weight: 600;
									color: #ff0e25;
								}

								&.active:before {
									width: 100%;
								}
							}

							& li:last-child {
								margin-right: 0;
							}
						}

						.ttshop-myorderseach {
							float: right;
							position: relative;

							input {
								width: 211px;
								height: 28px;
								border: 1px solid #ebebeb;
								font-size: 12px;
								color: #333;
								padding: 0 70px 0 8px;
								box-sizing: border-box;
								outline: none;
								border-radius: 2px;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:focus {
									border-color: #ff0e25;
								}
							}

							button {
								width: 62px;
								height: 26px;
								display: block;
								font-size: 12px;
								color: #333;
								text-align: center;
								position: absolute;
								top: 1px;
								right: 1px;
								border: 0;
								outline: none;
								background: #ebebeb;
								cursor: pointer;
								border-radius: 0 2px 2px 0;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									background: #ff0e25;
									color: #fff;
								}
							}
						}
					}

					.ttshop-myorderzw {
						width: 100%;
						min-height: 600px;
						background: #fff;
						padding-top: 180px;
						box-sizing: border-box;

						// display: none;
						img {
							display: block;
							width: 93px;
							height: 80px;
							margin: 0 auto 20px;
						}

						p {
							font-size: 14px;
							color: #333;
							text-align: center;
						}
					}

					.ttshop-myorderlist {
						width: 846px;

						.ttshop-myordertitle {
							width: 846px;
							background: #f5f5f5;
							height: 32px;
							margin-bottom: 20px;

							.ttshop-myordertext {
								float: left;
								width: 331px;
								padding-top: 8px;
								padding-left: 20px;
								box-sizing: border-box;

								.ttshop-myordertexter {
									display: table;
									// cursor: pointer;
									width: 297px;
									position: relative;
									div{
										display: flex;
										align-items: center;
										img{
											width: 12px;
											height: 12px;
										}
									}

									// p {
									// 	float: left;
									// 	font-size: 12px;
									// 	color: #333;
									// }
									select {
										font-size: 12px;
										border: none;
										outline: none;
										color: #999999;
										background: #F5F5F5;
										cursor: pointer;

										option {
											color: #999999;
											outline: none;
											text-indent: 12px;
										}
									}

									i {
										float: left;
										width: 12px;
										height: 12px;
										margin-top: 2px;

										img {
											display: block;
											width: 100%;
										}
									}
								}
							}

							.ttshop-myorderdj {
								float: left;
								width: 90px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}

							.ttshop-myorderdjs {
								float: left;
								width: 76px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}

							.ttshop-myorderzfje {
								float: left;
								width: 98px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}

							// .ttshop_myorderzt {
							//   float: left;
							//   width: 14%;
							//   padding-top: 8px;
							//   box-sizing: border-box;
							//   .ttshop_myorderzts {
							//     // cursor: pointer;
							//     p {
							//       float: left;
							//       font-size: 12px;
							//       color: #333;
							//     }
							//     i {
							//       float: left;
							//       width: 12px;
							//       height: 12px;
							//       margin-top: 2px;
							//       img {
							//         display: block;
							//         width: 100%;
							//       }
							//     }
							//   }
							// }
							.ttshop-myordercz {
								float: right;
								width: 150px;
								padding-top: 8px;
								box-sizing: border-box;

								p {
									font-size: 12px;
									color: #333;
									text-align: center;
								}
							}
						}

						.ttshop-myordercon {
							width: 100%;

							.ttshop-myorderconed {
								width: 100%;
								margin-bottom: 20px;

								.ttshop-myordercontitle {
									width: 100%;
									height: 32px;
									background: #f5f5f5;
									padding: 0 20px;
									box-sizing: border-box;
									line-height: 32px;

									p {
										float: left;
										font-size: 12px;
										color: #999;

										span {
											font-size: 12px;
											color: #999;
										}

										strong {
											color: #333;
											font-weight: 500;
										}
									}

									& p:last-child {
										margin-right: 0;
										// float: right;
									}

									.ttshop-myordercontitle-right {
										float: right;
										line-height: 32px;

										.ttshop-cancel {
											font-size: 12px;
											color: #999;
											// margin-bottom: 2px;
										}

										.ttshop-over {
											font-size: 12px;
											color: #ff0e25;
											margin-right: 24px; 
											// margin-bottom: 2px;
										}
										.ttshop-over-adopt{
											color: green;
										}
										.ttshop-over-examine{
											color: #FF9010;
										}

										strong {
											font-size: 12px;
											color: #ff0e25;
											font-weight: 400;
											cursor: pointer;
										}
									}
								}

								.ttshop-myorderconlist {
									width: 696px;
									min-height: 112px;
									border-left: 1px solid #ebebeb;
									border-bottom: 1px solid #ebebeb;
									box-sizing: border-box;
									border-right: 0;
									border-top: 0;

									.ttshop-myorderconleft {
										float: left;
										width: 50%;
										min-height: 112px;
										padding: 16px 20px 16px 10px;
										box-sizing: border-box;

										.ttshop-orderimg {
											float: left;
											width: 80px;
											height: 80px;
											margin-right: 12px;

											img {
												display: block;
												width: 100%;
												height: 100%;
												object-fit: cover;
											}
										}

										.ttshop-ordertext {
											float: left;
											width: 205px;

											h5 {
												font-size: 12px;
												color: #333333;
												font-weight: 500;
												line-height: 18px;
												display: -webkit-box;
												-webkit-box-orient: vertical;
												-webkit-line-clamp: 2;
												overflow: hidden;
												margin-bottom: 8px;
											}

											span {
												font-size: 12px;
												color: #999;
												margin-right: 5px;

												strong {
													font-weight: 400;
													font-size: 12px;
													color: #999;
												}
											}
										}
									}

									.ttshop-myorderdj {
										float: left;
										width: 11%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;

										p {
											font-size: 12px;
											color: #333;

											span {
												font-size: 12px;
												color: #333;
											}
										}
									}

									.ttshop-myorderdjer {
										border-right: 1px solid #ebebeb;
									}

									.ttshop-shr {
										float: left;
										width: 12%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;
										border-right: 1px solid #ebebeb;

										p {
											font-size: 12px;
											color: #333;
										}
									}

									.ttshop-zfzje {
										float: left;
										width: 16%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;
										border-right: 1px solid #ebebeb;

										p {
											font-size: 12px;
											color: #333;
											margin-bottom: 8px;

											span {
												font-size: 12px;
												color: #333;
											}
										}

										strong {
											font-size: 12px;
											color: #333;
											font-weight: 400;
											cursor: pointer;
											transition: 0.5s;
											-moz-transition: 0.5s;
											-webkit-transition: 0.5s;
											-o-transition: 0.5s;

											&:hover {
												color: #ff0e25;
											}
										}
									}

									// .ttshop_qbzt {
									//   float: left;
									//   width: 15%;
									//   text-align: center;
									//   padding-top: 16px;
									//   min-height: 138px;
									//   box-sizing: border-box;
									//   border-right: 1px solid #ebebeb;
									//   .ttshop_wfk {
									//     font-size: 12px;
									//     color: #ff8500;
									//     margin-bottom: 2px;
									//   }
									//   .ttshop_cancel {
									//     font-size: 12px;
									//     color: #999;
									//     margin-bottom: 2px;
									//   }
									//   .ttshop_over {
									//     font-size: 12px;
									//     color: #333;
									//     margin-bottom: 2px;
									//   }
									//   strong {
									//     font-size: 12px;
									//     color: #ff0e25;
									//     font-weight: 400;
									//     cursor: pointer;
									//   }
									// }

									.ttshop-caozuo {
										float: left;
										width: 16%;
										text-align: center;
										padding-top: 16px;
										min-height: 112px;
										box-sizing: border-box;
										border-right: 1px solid #ebebeb;

										.ttshop-ljzf {
											display: block;
											width: 72px;
											height: 24px;
											border: 1px solid #ff3346;
											background: #fff0f1;
											line-height: 24px;
											text-align: center;
											font-size: 12px;
											color: #ff0e25;
											margin: 0 auto 8px;
											border-radius: 2px;
											cursor: pointer;
										}

										.ttshop-cztext {
											font-size: 12px;
											color: #333;
											margin-bottom: 8px;
											cursor: pointer;
											transition: 0.5s;
											-moz-transition: 0.5s;
											-webkit-transition: 0.5s;
											-o-transition: 0.5s;

											&:hover {
												color: #ff0e25;
											}
										}

										.ttshop-hg {
											display: block;
											width: 72px;
											height: 24px;
											background: #ebebeb;
											line-height: 24px;
											text-align: center;
											font-size: 12px;
											color: #999;
											margin: 0 auto 8px;
											border-radius: 2px;
											cursor: pointer;
											transition: 0.5s;
											-moz-transition: 0.5s;
											-webkit-transition: 0.5s;
											-o-transition: 0.5s;

											&:hover {
												background: #ff0e25;
												color: #fff;
											}
										}

										.ttshop-queren {
											display: block;
											width: 72px;
											height: 24px;
											background: #ff0e25;
											line-height: 24px;
											text-align: center;
											font-size: 12px;
											color: #fff;
											margin: 0 auto 8px;
											border-radius: 2px;
											cursor: pointer;
										}
									}
								}
							}

							.ttshop-caozuos {
								float: right;
								width: 24%;
								text-align: center;
								padding-top: 16px;
								min-height: 112px;
								box-sizing: border-box;
								border-right: 1px solid #ebebeb;
								border-bottom: 1px solid #ebebeb;

								.ttshop-agree {
									width: 72px;
									height: 24px;
									line-height: 24px;
									background: rgba($color: #3FD44C, $alpha: 0.3);
									border-radius: 2px;
									border: 1px solid #3FD44C;
									font-size: 12px;
									font-family: PingFangSC-Regular, PingFang SC;
									font-weight: 400;
									color: #17CD27;
									margin-bottom: 8px;
									cursor: pointer;
								}

								.ttshop-refuse {
									width: 72px;
									height: 24px;
									line-height: 24px;
									background: rgba($color: #FF3346, $alpha: 0.3);
									border-radius: 2px;
									border: 1px solid #FF3346;
									font-size: 12px;
									font-family: PingFangSC-Regular, PingFang SC;
									font-weight: 400;
									color: #FF3346;
									margin-bottom: 8px;
									cursor: pointer;
								}


								.ttshop-cztexts {
									font-size: 12px;
									color: #ff0e25;
									margin-bottom: 8px;
								}

								.ttshop-ljzf {
									display: block;
									width: 72px;
									height: 24px;
									border: 1px solid #ff3346;
									background: #fff0f1;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #ff0e25;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
								}

								.ttshop-cztext {
									font-size: 12px;
									color: #333;
									margin-bottom: 8px;
									cursor: pointer;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;

									&:hover {
										color: #ff0e25;
									}
								}

								
								.ttshop-zf {
									display: block;
    							width: 72px;
    							height: 24px;
    							border: 1px solid #ff3346;
    							background: #fff0f1;
    							line-height: 24px;
    							text-align: center;
    							font-size: 12px;
    							color: #ff0e25;
    							margin: 0 auto 8px;
    							border-radius: 2px;
    							cursor: pointer;
								}

								.ttshop-hg {
									display: block;
									width: 72px;
									height: 24px;
									background: #ebebeb;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #999;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;

									&:hover {
										background: #ff0e25;
										color: #fff;
									}
								}

								.ttshop-queren {
									display: block;
									width: 72px;
									height: 24px;
									background: #ff0e25;
									line-height: 24px;
									text-align: center;
									font-size: 12px;
									color: #fff;
									margin: 0 auto 8px;
									border-radius: 2px;
									cursor: pointer;
								}
							}
						}

						.ttshop-myorderpage {
							width: 100%;
							margin-top: 32px;

							.ttshop-pages {
								float: right;
							}
						}
					}
				}
			}
		}
	}


	// 订单审批
	.addpersonal {
		background: #EBEBEB;

		.add-per {
			background: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;

			.add-per-text {
				box-sizing: border-box;
				width: 420px;
				height: 109px;
				resize: none;
				border: 1px solid #EBEBEB;
				padding-top: 8px;
				padding-left: 12px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				line-height: 12px;
				outline: none;
			}
		}

		.newly-build {
			width: 108px;
			height: 32px;
			margin: 0 auto;
			background: #FF0E25;
			border-radius: 2px;
			font-size: 12px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #FFFFFF;
			line-height: 32px;
			text-align: center;
			margin-top: 32px;
			cursor: pointer;
		}
	}
</style>
